var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "default-modal",
        {
          attrs: {
            name: "add-item-modal",
            autofocus: _vm.$refs.itemsForm,
            successHandler: _vm.handleSave,
            title: _vm.$t("add_item"),
            width: "sm"
          },
          model: {
            value: _vm.modalOpened,
            callback: function($$v) {
              _vm.modalOpened = $$v
            },
            expression: "modalOpened"
          }
        },
        [
          _c("items-form", {
            ref: "itemsForm",
            attrs: { slot: "content" },
            slot: "content"
          })
        ],
        1
      ),
      _c(
        "q-page-sticky",
        { attrs: { position: "bottom-right", offset: [18, 18] } },
        [
          _c(
            "q-btn",
            {
              staticClass: "add-item__button",
              attrs: { color: "primary", round: "", fab: "" },
              on: {
                click: function($event) {
                  _vm.modalOpened = true
                }
              }
            },
            [_c("q-icon", { attrs: { name: "add" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }